<script>
export default {
  name: 'IntelligenceV2PersonaAviso',
  props: {
    // Vem de `persona.aviso`, que aponta para a ÚNICA constante
    // AVISO_NAO_ACONSELHAMENTO. O componente não conhece a copy — só a renderiza.
    texto: {
      type: String,
      required: true,
    },
    // Centra a linha inteira. A centralização vive AQUI e não na view que usa o
    // componente porque o gate de design-system barra `justify-content` e
    // `text-align` no `<style>` de view de módulo — e com razão: os dois têm
    // utilitário. Como prop, sai em classe utilitária e não em CSS novo.
    centralizado: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classeLinha() {
      return this.centralizado ? 'justify-center text-center' : ''
    },
  },
}
</script>

<template>
  <div class="persona-aviso">
    <div class="d-flex align-center" :class="classeLinha">
      <span class="persona-aviso__texto az-text-secondary az-muted ia-texto-auxiliar">{{ texto }}</span>
    </div>
  </div>
</template>

<style lang="sass" scoped>
// O passo de 11px vem de `design/_ia-texto.sass` (classe no template).
.persona-aviso__texto
  line-height: 16px
</style>
